import React, { useState } from 'react';
import { Button, TextField } from '@material-ui/core';
import 'react-toastify/dist/ReactToastify.css';
import './PaymentOption.scss';
import { IonRow, IonCol, IonSelect, IonSelectOption } from '@ionic/react';
import './PaymentOption.scss';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import API from '../../../api';
import { toast } from 'react-toastify';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import { useSelector } from 'react-redux';
import { RootState } from '../../../models/RootState';
type StoreProps = {};

const Paytm: React.FC<StoreProps> = (props) => {
  const [errorMsg, setErrorMsg] = useState<string>(null);
  const langData = useSelector((state: RootState) => state.common.langData)

  const handleImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      getBase64(file).then((data) => {
        formik.setFieldValue('imageCode', data);
      });
    }
  };

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  const formik = useFormik({
    initialValues: {
      accountNumber: '',
      amount: 0,
      beneficiaryName: '',
      imageCode: '',
      phone: '',
      referenceTransaction: '',
      transactionStatusType: 'IN_PROGRESS',
      transactionsType: 'BANK_TRANSACTION',
      upi: '',
    },
    validationSchema: Yup.object({
      accountNumber: Yup.string(),
      amount: Yup.number().required('Amount is required'),
      beneficiaryName: Yup.string().required('Beneficiary Name is required'),
      phone: Yup.string().required('Paytm wallet no. is required'),
      imageCode: Yup.string(),
      referenceTransaction: Yup.string(),
      transactionStatusType: Yup.string(),
      transactionType: Yup.string(),
      upi: Yup.string(),
    }),

    onSubmit: async (values) => {
      let postBody = {
        accountNumber: values.accountNumber,
        amount: values.amount,
        beneficiaryName: values.beneficiaryName,
        imageCode: values.imageCode,
        phone: values.phone,
        referenceTransaction: values.referenceTransaction,
        transactionStatusType: 'IN_PROGRESS',
        transactionsType: 'PAYTM',
        upi: values.upi,
        deposit: true,
      };
      try {
        const response: any = await API.post(
          '/offline-transaction/add-transaction',
          postBody,
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
          }
        );
        if (response.status === 200) {
          formik.resetForm();
          toast.success(
            <div>
             <SuccessIcon />{langData?.['transaction_added_successfully']}
            </div>,
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        }
      } catch (err) {
        toast.error(<div>{String(err.response.data.error)}</div>, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    },
  });

  return (
    <div className="payment-option-ctn">
      <div className="header">
        <div className="title">Paytm Details</div>
      </div>

      <form
        onSubmit={formik.handleSubmit}
        className="login-form-ctn"
        autoComplete="off"
      >
        <IonRow className="input-row">
          <IonCol sizeXs="12" sizeSm="12" sizeMd="4" sizeLg="4">
            <div className="input-row">
              <div className="lable">Benificiary Name</div>
              {/* <IonSelect
                value={formik.values.beneficiaryName}
                placeholder="Select One"
                interface="popover"
                onIonChange={(e) => formik.setFieldValue('beneficiaryName', e.detail.value)}
                className="input-select"
                {...formik.getFieldProps('beneficiaryName')}
              >
                <IonSelectOption value="" hidden={true} disabled>
                  Select One
                </IonSelectOption>
                <IonSelectOption value="vegas01">vegas01</IonSelectOption>
              </IonSelect> */}
              <TextField
                type="text"
                variant="outlined"
                className="input-control"
                autoComplete="none"
                placeholder="Beneficiary Name"
                error={
                  formik.touched.beneficiaryName &&
                  formik.errors.beneficiaryName !== undefined
                }
                helperText={
                  formik.touched.beneficiaryName &&
                  formik.errors.beneficiaryName
                    ? formik.errors.beneficiaryName
                    : null
                }
                {...formik.getFieldProps('beneficiaryName')}
              />
            </div>
          </IonCol>

          <IonCol sizeXs="12" sizeSm="12" sizeMd="4" sizeLg="4">
            <div className="input-row">
              <div className="lable">UPI ID</div>
              <TextField
                type="text"
                variant="outlined"
                className="input-control"
                autoComplete="none"
                placeholder="UPI ID"
                error={formik.touched.upi && formik.errors.upi !== undefined}
                helperText={
                  formik.touched.upi && formik.errors.upi
                    ? formik.errors.upi
                    : null
                }
                {...formik.getFieldProps('upi')}
              />
            </div>
          </IonCol>
          <IonCol sizeXs="12" sizeSm="12" sizeMd="4" sizeLg="4">
            <div className="input-row">
              <div className="lable">Paytm No.</div>
              <TextField
                type="text"
                variant="outlined"
                className="input-control"
                autoComplete="none"
                placeholder="Paytm No."
                error={
                  formik.touched.phone && formik.errors.phone !== undefined
                }
                helperText={
                  formik.touched.phone && formik.errors.phone
                    ? formik.errors.phone
                    : null
                }
                {...formik.getFieldProps('phone')}
              />
            </div>
          </IonCol>
        </IonRow>

        <IonRow>
          <IonCol sizeXs="12" sizeSm="12" sizeMd="4" sizeLg="4">
            <div className="input-row">
              <div className="lable">TRN REF No.</div>
              <TextField
                type="text"
                variant="outlined"
                className="input-control"
                autoComplete="none"
                placeholder="TRN REF No."
                {...formik.getFieldProps('referenceTransaction')}
              />
            </div>
          </IonCol>

          <IonCol sizeXs="12" sizeSm="12" sizeMd="4" sizeLg="4">
            <div className="input-row">
              <div className="lable">Enter Amount</div>
              <TextField
                type="number"
                variant="outlined"
                className="input-control"
                autoComplete="none"
                placeholder="Enter Amount."
                error={
                  formik.touched.amount && formik.errors.amount !== undefined
                }
                helperText={
                  formik.touched.amount && formik.errors.amount
                    ? formik.errors.amount
                    : null
                }
                {...formik.getFieldProps('amount')}
              />
            </div>
          </IonCol>
          <IonCol sizeXs="12" sizeSm="12" sizeMd="4" sizeLg="4">
            <div className="input-row">
              <div className="lable">Upload Screenshot</div>
              <TextField
                name="upload-photo"
                type="file"
                inputProps={{ accept: 'image/*' }}
                className="file-control"
                onChange={(e) => handleImage(e)}
              />
            </div>
          </IonCol>
        </IonRow>
        {errorMsg !== '' ? (
          <span className="login-err-msg">{errorMsg}</span>
        ) : null}

        <div className="btn-section">
          <Button
            variant="contained"
            type="submit"
            color="primary"
            className="btn"
            disabled={!formik.isValid}
          >
            Deposit Request Submit
          </Button>
        </div>

        <div className="btn-section img-ctn">
          {formik.values.imageCode ? (
            <>
              <label>Uploaded Image</label>
              <img className="img-code" src={formik.values.imageCode} />
            </>
          ) : null}
        </div>
      </form>
    </div>
  );
};

export default Paytm;
